import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import intl from '@utils/intl'
import {createRandomCode} from '@src/utils'
import {loginStoreG} from '@src/containers/viewsG/login/actor/store';

class RegisterStoreG extends StoreExt {
    @observable randomCode: string = createRandomCode()
    @observable captchaUrl: string = this.api.getCaptchaUrl(this.randomCode)
    @observable title = intl.formatMessage({id: 'register.sendMsg.text'})
    private timer: any
    private lock: boolean = false // 控制是否倒计时中

    @action
    getVerifyCode = async (param) => {
        if (this.lock) {
            return
        }
        let baseTimer = 60
        this.lock = true
        runInAction(() => {
            this.title = '60s'
        })
        this.timer = setInterval(() => {
            baseTimer--
            if (baseTimer <= 0) {
                clearInterval(this.timer)
                this.lock = false
            }
            runInAction(() => {
                this.title = baseTimer <= 0 ? intl.formatMessage({id: 'register.sendMsg.reSend'}) : `${baseTimer}s`
            })
        }, 1000)
        try {
            await this.api.getRegisterMsgCode(param)
            this.$toast.info(intl.formatMessage({id: 'register.sendMsg.sendSuccess'}))
        } catch (e) {
            this.refreshImgCode()
        }
    }

    @action
    refreshImgCode = () => {
        const randomCodeUrl = createRandomCode()
        this.randomCode = randomCodeUrl
        this.captchaUrl = this.api.getCaptchaUrl(randomCodeUrl)
    }

    @action
    handleSignUp = async (param) => {
        this.showLoading()
        try {
            await this.api.registerByUser(param)
            this.$toast.info(intl.formatMessage({id: 'register.success'}), 1, () => {
                loginStoreG.handleLogin(param.phoneNumb, param.password, true)
            })
        } catch (e) {} finally {
            this.hideLoading()
        }
    }
    
    @action
    getOperatorId = async (simId) => {
        try {
            const res = await this.api.getOperatorId({ simId })
            return res
        } catch (e) {
        }
    }
}

const registerStoreG = new RegisterStoreG()
export {registerStoreG, RegisterStoreG}
